import React from "react";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import BoltIcon from "@mui/icons-material/Bolt";
import { Box } from "@mui/material";
import CustomCard from "../../shared/CustomCard";

function ReportCard() {
  const priceReports = [
    {
      title: "Cash Price List",
      icon: AttachMoneyIcon,
      path: "/reports/cash-price-list",
    },
    {
      title: "Power wide Price",
      icon: BoltIcon,
      path: "/reports/power-wide-price",
    },
  ];

  return (
    <Box sx={{ p: 3 }}>
      <Box className=" grid grid-cols-1 gap-3 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
        {priceReports.map((report, index) => (
          <CustomCard
            key={index}
            title={report.title}
            icon={report.icon}
            path={report.path}
            color="#0070C2"
          />
        ))}
      </Box>
    </Box>
  );
}

export default ReportCard;
